function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { Guid as G } from "../../shared-lib/index.js";

var u = /*#__PURE__*/function () {
  function u() {
    _classCallCheck(this, u);

    this.Ir = {};
  }

  _createClass(u, [{
    key: "Ns",
    value: function Ns(t) {
      if ("function" != typeof t) return null;
      var i = G.Rt();
      return this.Ir[i] = t, i;
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription(t) {
      delete this.Ir[t];
    }
  }, {
    key: "removeAllSubscriptions",
    value: function removeAllSubscriptions() {
      this.Ir = {};
    }
  }, {
    key: "ic",
    value: function ic() {
      return Object.keys(this.Ir).length;
    }
  }, {
    key: "X",
    value: function X(t) {
      var i = [];

      for (var s in this.Ir) {
        var r = this.Ir[s];
        i.push(r(t));
      }

      return i;
    }
  }]);

  return u;
}();

export { u as default };